import React from "react";
import { Navigate } from "react-router-dom";

// Helper para obter dados frescos do usuário para re-renderizações após login sem refresh nativo
const getUserData = () => {
  const user = JSON.parse(localStorage.getItem("GT_user")) || {};
  const permissions = user?.permissions || [];
  return { user, permissions };
};

//Componente para rodear outros components e caso não tenha permissão esconder o componente
export const SecurityPath = ({ children, securePaths = [] }) => {
  if (securePaths.length === 0) return children;
  const { permissions } = getUserData();

  const hasPermission = securePaths?.some((securePath) =>
    permissions?.some((permissionObj) => permissionObj.securityPermission === securePath)
  );
  if (hasPermission) return children;
  return null;
};

//Componente para rodear as rotas e caso não tenha permissão redirecionar para dashboard do módulo
export const SecurityRoute = ({
  children,
  secureMainRoute = null,
  securePaths = [],
  returnTo = "/",
}) => {
  let hasPermission = false;
  const { permissions } = getUserData();

  if (secureMainRoute === "admin") {
    hasPermission = hasAdminPermission();
  }

  if (secureMainRoute === "reinf") {
    hasPermission = hasReinfPermission();
  }

  if (secureMainRoute === null) {
    if (securePaths.length === 0) return children;
    hasPermission = securePaths?.some((securePath) =>
      permissions?.some((permissionObj) => permissionObj.securityPermission === securePath)
    );
  }

  if (hasPermission) return children;

  return <Navigate to={returnTo} />;
};

//Função que retornar true/false para condicionais
export const hasPermission = (securePaths = []) => {
  if (securePaths.length === 0) {
    return true;
  }
  const { permissions } = getUserData();

  const hasPermission = securePaths?.some((securePath) =>
    permissions?.some((permissionObj) => permissionObj.securityPermission === securePath)
  );

  return hasPermission;
};

//Função que retorna se o usuário tem alguma permissão de admin
export const hasAdminPermission = () => {
  const { permissions } = getUserData();
  const adminPerm = permissions?.some(
    (permission) => permission.securityPermission.split("\\")[0] === "admin"
  );
  return adminPerm;
};

//Função que retorna se o usuário tem alguma permissão de reinf
export const hasReinfPermission = () => {
  const { user, permissions } = getUserData();

  if (user?.companyInfor?.companyPlan?.isAllowReinf) {
    const reinfPerm = permissions?.some(
      (permission) => permission.securityPermission.split("\\")[0] === "reinf"
    );
    return reinfPerm;
  }
};

//Função que retorna se o usuário tem alguma permissão de cliente
export const hasClientPermission = () => {
  const { permissions } = getUserData();
  const clientPerm = permissions?.some(
    (permission) => permission.securityPermission.split("\\")[0] === "client"
  );
  return clientPerm;
};

//Função que retorna se o usuário possui determinada permissão do plano (módulos, funcionalidades ou relatórios)
export const hasPlanPermission = (code) => {
  if (!code) return false;
  const { user } = getUserData();
  const plan = user?.companyInfor?.companyPlan;
  if (!plan) return false;

  return (
    plan.modules?.includes(code) ||
    plan.features?.includes(code) ||
    plan.reports?.includes(code) ||
    false
  );
};

// Função que retorna se o usuário possui determinada flag booleana no plano (ex: isConsultISS, isCalculationSimulator, isGenerateReport)
export const isPlanFeatureAllowed = (featureFlag) => {
  const { user } = getUserData();
  const plan = user?.companyInfor?.companyPlan;
  if (plan && typeof plan[featureFlag] === "boolean") {
    return plan[featureFlag];
  }
  return false;
};

